import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { TaxTypeType } from './types.ts'
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft} from "lucide-react";

interface EditProps {
  tax_type: TaxTypeType
}

export default function Edit({ tax_type }: EditProps) {
  return (
    <>
      <Head title="Editing tax type" />

      <div className="p-8">
        <div className="mb-6">
          <Link href="/admin/tax_types">
            <Button variant="ghost" size="sm" className="mb-4 gap-2">
              <ArrowLeft className="h-4 w-4" />
              Retour
            </Button>
          </Link>
          <h1 className="font-bold text-4xl">Editer {tax_type.name}</h1>
        </div>


        <Form
          tax_type={tax_type}
          action={`/admin/tax_types/${tax_type.id}`}
          method="patch"
          submitText="Mettre à jour le type de taxe"
        />

      </div>
    </>
  )
}
